// Glow & You - Brand Colors (STRICT - Do not modify)
export const BRAND_COLORS = {
  // Primary
  bordeaux: '#6B2737',
  
  // Secondary
  cream: '#F5F0E8',
  
  // Accent
  gold: '#C9A84C',
  
  // Backgrounds
  darkWarm: '#2C2420',
  lightCream: '#EDE6D6',
  
  // Legacy colors (to be replaced gradually)
  legacy_brown: '#8B4513',
  legacy_sage: '#C4B5A0',
  legacy_lightCream: '#FAF9F7',
  legacy_border: '#D4C4B0',
  legacy_gray: '#8B7D6B',
  legacy_charcoal: '#2C2C2C'
};

// Typography
export const BRAND_FONTS = {
  heading: 'Cormorant Garamond, serif',
  body: 'Jost, sans-serif'
};
